import React from 'react';

import * as css from './Text.module.css';

export default function Text({ children, size, ...props }) {
  return (
    <article className={css.Text} data-size={size} {...props}>
      {children}
    </article>
  );
}

Text.defaultProps = {
  size: 'default',
};
